import React from 'react';
import { ObjectWrapper } from './styles/Common.styles';
import { StyledInput } from './styles/Input.styles'; // Reusing the input style
import { PasswordPreviewDiv } from './styles/PasswordInput.styles';

const PasswordInputControl = ({ control, renderMode }) => {
  // For mobile, render a real functional password input
  if (renderMode === 'mobile') {
    return (
      <ObjectWrapper>
        <StyledInput
          type="password"
          styleProps={control.attributes}
          defaultValue={control.defaultValue}
          placeholder={control.placeholder}
          height={control.height}
          renderMode={renderMode}
          readOnly
        />
      </ObjectWrapper>
    );
  }

  // For the desktop preview, render a div with asterisks
  const valueLength = control.defaultValue ? String(control.defaultValue).length : 0;
  const asterisks = '*'.repeat(valueLength);

  return (
    <ObjectWrapper>
      <PasswordPreviewDiv
        styleProps={control.attributes}
        height={control.height}
      >
        {asterisks}
      </PasswordPreviewDiv>
    </ObjectWrapper>
  );
};

export default PasswordInputControl;